export default "__VITE_ASSET__BEfwZljI__"